import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CampaningManager from '../../views/CampaningManager/CampaningManager';

const CampaningManagerPageRoute = () => {
    return (
        <div>
            <Routes>
                <Route path="/campaning_manager" element={<CampaningManager />} />
                <Route path="/" element={<Navigate to="/campaning_manager" replace />} />
            </Routes>
        </div>
    );
};

export default CampaningManagerPageRoute;



